export const enum AgeGateCookieEnum {
    CookieName = "ageCheck",
    ConsentAllValue = "a",
    ConsentReqValue = "r",
    CookieDuration = 3600 * 24 * 30, // 30 days, in seconds
}
